import React from 'react'
import {
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
} from '@mui/material'
import WatchLaterIcon from '@mui/icons-material/WatchLater'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import moment from 'moment'
import { useStyles } from '../../pages/Appointment/details/styles'
import { useTranslation } from 'react-i18next'
import axios from 'axios'

const ServiceTimePicker = ({
                               errors,
                               control,
                               register,
                               selectedDate,
                               availableTimes,
                           }) => {
    const classes = useStyles()
    const { t } = useTranslation()
    const now = new Date()

    // Return null if it's the current day and past 6 PM
    if (selectedDate.isSame(moment(now), 'day') && now.getHours() > 18) {
        return null
    }

    // Ensure availableTimes is an array
    const safeAvailableTimes = Array.isArray(availableTimes) ? availableTimes : []

    const handleTimeChange = async (time) => {
        try {
            await axios.post(`${process.env.REACT_APP_API_KEY}/arscustom/public/appointment/select-time`, {
                time,
            })
        } catch (error) {
            console.error('Error selecting time', error)
        }
    }

    return (
        <FormControl fullWidth className={classes.textfield}>
            <InputLabel htmlFor="time" color="secondary">
                {t('form.time')}
            </InputLabel>
            <Controller
                name="time"
                control={control}
                render={({ field }) => (
                    <Select
                        {...register('time')}
                        {...field}
                        labelId="service-time-label"
                        label={t('form.time')}
                        IconComponent={WatchLaterIcon}
                        MenuProps={{
                            PaperProps: { sx: { maxHeight: 240 } },
                        }}
                        value={field?.value || ''}
                        onChange={(e) => {
                            field.onChange(e.target.value)
                            handleTimeChange(e.target.value)
                        }}
                        disabled={!selectedDate.isValid() || !safeAvailableTimes.length}
                    >
                        {safeAvailableTimes.length ? (
                            safeAvailableTimes.map((option) => (
                                <MenuItem
                                    key={option}
                                    value={option}
                                    style={{
                                        background: option === field.value ? '#1A1C3A' : '',
                                        color: option === field.value ? '#FCFCFC' : '#1A1C3A',
                                    }}
                                >
                                    {option}
                                </MenuItem>
                            ))
                        ) : (
                            <MenuItem disabled>{t('form.no_times_available')}</MenuItem>
                        )}
                    </Select>
                )}
            />
            {errors.time && (
                <FormHelperText style={{ color: 'red' }}>
                    {errors.time.message}
                </FormHelperText>
            )}
        </FormControl>
    )
}

ServiceTimePicker.propTypes = {
    control: PropTypes.object.isRequired,
    errors: PropTypes.object,
    register: PropTypes.func,
    selectedDate: PropTypes.any,
    availableTimes: PropTypes.arrayOf(PropTypes.string),
}

export default ServiceTimePicker